import { BadgeVariants } from '@carboledger/ui';
import { UNIT_TYPES } from '@/config/unitTypes.constants';
import { ORDER_DISPLAY_STATUS_TONE } from './orderDisplayStatusTone';

// The header's discrepancy modal field sections.
export const buildOrderDiscrepancySections = (t, order) => {
  if (!order) return [];
  // The order's own default unit — same rule tables use (defaultUnitType).
  const unitType = order.workingUnit ? UNIT_TYPES.working : UNIT_TYPES.declaration;
  const quantities = order.byUnit?.[unitType];
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: order.materialName },
        {
          label: t('FIELD_STATUS'),
          value: order.statusLabel,
          type: 'status',
          tone: ORDER_DISPLAY_STATUS_TONE[order.statusCode] ?? BadgeVariants.default,
        },
        { label: t('FIELD_SOLD_TO'), value: order.soldTo },
        { label: t('FIELD_SHIPPING_TO'), value: order.shippingTo },
        { label: t('FIELD_DISPATCH_BY'), value: order.dispatchBy },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_CONTRACTED_QUANTITY'), value: quantities?.contractedQuantity },
        { label: t('FIELD_SHIPPED_QUANTITY'), value: quantities?.shippedQuantity },
        { label: t('ORDERS_COL_REMAINING_TO_SHIP'), value: quantities?.remainingToShipQuantity },
      ],
    },
  ];
};

// The LIST row's discrepancy modal — a row carries no status code, so it shows none.
export const buildOrderRowDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType ?? row.unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: row.materialName },
        { label: t('FIELD_FACILITY_NAME'), value: row.facilityName },
        { label: t('FIELD_TERMINAL'), value: row.terminal },
        { label: t('FIELD_SOLD_TO'), value: row.soldTo },
        { label: t('FIELD_SHIPPING_TO'), value: row.shippingTo },
        { label: t('FIELD_DISPATCH_BY'), value: row.dispatchBy },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_CONTRACTED_QUANTITY'), value: unit.contractedQuantity },
        { label: t('FIELD_SHIPPED_QUANTITY'), value: unit.shippedQuantity },
        { label: t('ORDERS_COL_REMAINING_TO_SHIP'), value: unit.remainingToShipQuantity },
      ],
    },
  ];
};

// The Linked outgoing shipments tab's row modal — a shipment row, not an order row.
export const buildLinkedShipmentDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType ?? row.unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_SHIPMENT_ID'), value: row.shipmentId },
        { label: t('FIELD_SHIPPING_TO'), value: row.shippingTo },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: row.dateOfDispatch },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: unit.shipmentQuantity },
        { label: t('FIELD_ALLOCATED_QUANTITY'), value: unit.allocatedQuantity },
        {
          label: t('FIELD_REMAINING_TO_ALLOCATE_QUANTITY'),
          value: unit.remainingToAllocateQuantity,
        },
      ],
    },
  ];
};
